import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { captureAttioPhoneFromUrl } from "./Utils/attioDeepLink";
import { Provider } from "react-redux";
import { store } from "./redux/store.ts";
import { registerSW } from "virtual:pwa-register";
// import { getRecipients } from "./redux/reducers/messengerSlice";
// import { fetchLabels } from "./redux/reducers/authSlice";

// Capture Attio phone from URL before React renders (survives auth redirects)
captureAttioPhoneFromUrl();

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    deferredPrompt: any;
  }
}

// Then in your event listener section:
window.addEventListener("beforeinstallprompt", (e) => {
  // Prevent the mini-infobar from appearing on mobile
  e.preventDefault();
  // Store the event for later use
  window.deferredPrompt = e;
  // console.log("✅ beforeinstallprompt fired!", e);
});

// Register service worker with auto-update
const updateSW = registerSW({
  onNeedRefresh() {
    if (confirm("New content available. Reload?")) {
      updateSW(true);
    }
  },
  onOfflineReady() {

  },
});

// Debug PWA criteria
if ("serviceWorker" in navigator) {
  // console.log('✅ Service Worker API supported');
      navigator.serviceWorker.getRegistrations().then(() => {
      
    });
} else {
  
}

window.addEventListener("load", () => {
  // Small delay sometimes helps trigger the event
  setTimeout(() => {
    // Sometimes refreshing service worker registration helps
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (const registration of registrations) {
          registration.update();
        }
        // console.log('Updated service worker registrations');
      });
    }
  }, 1000);
});

// Listen for auth token messages from parent window (for embedded usage)
window.addEventListener('message', (event) => {
  // Verify origin for security
  const allowedOrigins = [
    'https://your-main-app-domain.com', // Replace with your actual domain
    'http://localhost:3000', // For development
    'http://localhost:5173', // Vite dev server default port
    'https://console.notifyer-systems.com' // Based on the console URL in your app
  ];
  
  if (!allowedOrigins.includes(event.origin)) {
    return;
  }
  
  if (event.data.type === 'SET_AUTH_TOKEN') {

    // The authToken from URL parameters will be used automatically by getAuthToken() utility
    // No need to do anything special here
  }
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
